import { render, staticRenderFns } from "./month.vue?vue&type=template&id=dea64c34&"
import script from "./month.vue?vue&type=script&lang=js&"
export * from "./month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports